import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';

export const softwareSettingsNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'Update',
    route: { name: routenames.update },
  },
  {
    titleI18n: 'Maintenance',
    route: { name: routenames.maintenance },
  },
  {
    titleI18n: 'SSLCertificate',
    route: { name: routenames.sslCertificate },
  },
  {
    titleI18n: 'InstallationName',
    route: { name: routenames.installationName },
  },
  {
    titleI18n: 'EmailSettings',
    route: { name: routenames.emailSettings },
  },
  {
    titleI18n: 'Database',
    route: { name: routenames.databaseSettings },
  },
  {
    titleI18n: 'Backup',
    route: { name: routenames.backup },
  },
];
